import { useEffect, useState } from "react";
import { ITitle } from "../../models/interfaces/ITitle";
import DropdownSelector from "../DropDownSelector";
import { DEFAULT_LOCAL_STORAGE_SORT } from "../../utils/helpers";
import { ISorter } from "../../models/interfaces/ISorter";

interface IProps {
  columnsIndex: number[];
  titles: ITitle[];
  setSorter: (sortFunction: () => (a: any, b: any) => number) => void;
  sorter?: ((a: any, b: any) => number) | undefined;
  setColumnFiltered: React.Dispatch<React.SetStateAction<string>>;
  setFilterValue: React.Dispatch<React.SetStateAction<string>>;
  possibleValues: string[];
  actualFilterPage: string;
  updateSorter?: (field: string) => void;
  updateDescending?: (value: boolean) => void; 
}

const TableHeader: React.FC<IProps> = ({
  titles,
  columnsIndex,
  setSorter,
  sorter,
  setColumnFiltered,
  setFilterValue,
  possibleValues,
  actualFilterPage,
  updateSorter,
  updateDescending
}: IProps) => {
  const [orderedcolumnname, setorderedcolumnname] = useState("");
  const [orderedasc, setorderedasc] = useState<boolean | null>(null);

  const handleSort = (TitleElement:any) => {
    setorderedcolumnname(TitleElement?.Name);
    if (updateSorter) {
        updateSorter(TitleElement?.Id);
    }

    let orderAsc: boolean;
    if (TitleElement && TitleElement.sorter !== undefined && TitleElement.sorter !== null) {
        if (sorter === TitleElement.sorter) {
            setSorter(() => (a :any, b:any) => TitleElement.sorter!(b, a));
            setorderedasc(true);
            orderAsc = true;
          } else {
            setSorter(() => TitleElement.sorter!);
            setorderedasc(false);
            orderAsc = false;
          }

          if (updateDescending) {
            updateDescending(orderAsc);
        }
    
        const sortStore:ISorter = {
          sorter,
          orderedcolumnid: TitleElement?.Id,
          orderedcolumnname: TitleElement?.Name,
          orderedasc: !orderAsc,
          actualFilterPage,
        }
        localStorage.setItem("ISortStore", JSON.stringify(sortStore));
    }
    
  };

  useEffect(() => {
    sorter && handleSort(sorter);
    
    if (localStorage.getItem("ISortStore") !== DEFAULT_LOCAL_STORAGE_SORT) {
        const localStorageSort = localStorage.getItem("ISortStore");
        const ISorterSelection = localStorageSort ? JSON.parse(localStorageSort) : null;
        if (ISorterSelection?.actualFilterPage !== actualFilterPage) {
          localStorage.setItem("ISortStore",JSON.stringify(DEFAULT_LOCAL_STORAGE_SORT));
          return;
        }
      setorderedasc(!ISorterSelection.orderedasc)
      setorderedcolumnname(ISorterSelection.orderedcolumnname)
      titles.map((TitleElement) => {
        if (TitleElement.Name === ISorterSelection.orderedcolumnname) {
            const sorter = TitleElement.sorter;
            if (sorter) {
                // If sorter is defined, set it to the sorter state, reversing it if necessary
                setSorter(ISorterSelection.orderedasc ? () => sorter : () => (a, b) => sorter.call(this, a, b) * -1);
            }
          //setSorter(ISorterSelection.orderedasc ? () => TitleElement.sorter : () => (a, b) => TitleElement.sorter.call(this, a, b) * -1)
        } 
      })
      if (ISorterSelection.filterValue) {
        setColumnFiltered("Titre")
        setFilterValue(ISorterSelection.filterValue)
      }
    }
  }, []);

  const handleColumnFiltered = (name:string) => {
    setColumnFiltered(name);
    setFilterValue("");
  };

  const handleSetFilterValue = (name:string) => {
    // const ISorterSelection = {
    //   sorter,
    //   orderedcolumnname,
    //   orderedasc: !orderedasc,
    //   actualFilterPage,
    //   filterValue: name,
    // }
    setFilterValue(name);
    //localStorage.setItem("ISortStore", JSON.stringify(ISorterSelection));
  }

  function getClassHeaderColumn(TitleElement:ITitle) {
    let classValue = "bi";

    if (orderedcolumnname === TitleElement.Name) {
      if (orderedasc) {
        classValue += " bi-sort-up";
      } else {
        classValue += " bi-sort-down";
      }
    } else {
      classValue += " bi-arrow-down-up";
    }

    return classValue;
  }

  return (
    <>
      {titles?.map((TitleElement, TitleElementIdx) => {
        return (
          Object.values(columnsIndex).filter((idx) => idx === TitleElementIdx)
            .length > 0 && (
            <th
              key={TitleElementIdx}
              className={
                orderedcolumnname === TitleElement.Name
                  ? "ordered " + TitleElement?.Class
                  : TitleElement?.Class
              }
            >
              <div className="btn-group">
                {<p>{TitleElement.Name}</p>}
                {TitleElement.isFilterable && (
                  <DropdownSelector
                    name={TitleElement.Name}
                    data={possibleValues}
                    setColumnFiltered={() =>
                      handleColumnFiltered(TitleElement?.Id)
                    }
                    setFilterValue={handleSetFilterValue}
                  />
                )}
                {TitleElement.sorter && (
                  <i
                    className={getClassHeaderColumn(TitleElement)}
                    onClick={() => handleSort(TitleElement)}
                  />
                )}
              </div>
            </th>
          )
        );
      })}
    </>
  );
};

export default TableHeader;
